import { Card, Grid } from '@mui/material';
import React, { useMemo } from 'react';
import { BillActions } from '.';
import PatientInfo from '../../../components/PatientInfo';
import BillsTable from './BillsTable';
import { Bill } from './types';
import { IInsurance } from '../../../constants/types';

type BillsPatientProps = {
    uuidPatient: string;
    bills: Bill[];
    languageCode: string;
    canCreateBugdet: boolean;
    canCancelDocument?: boolean;
    currency: string;
    patient:any;
    makeActionBillCallBack: (index:number, action:BillActions) => void;
    hasBudgets: boolean;
    insurances?: IInsurance[];
};

const BillsPatient: React.FC<BillsPatientProps> = ({ uuidPatient, currency, patient, bills, languageCode, canCreateBugdet, canCancelDocument, makeActionBillCallBack, hasBudgets, insurances }) => {
    const totalBills = useMemo(() => {
        return bills.reduce((total, bill) => {
            return {total: total.total + Number(bill.totalGross - bill.totalDiscount), totalPaid: total.totalPaid + Number(bill.totalPaid)}
        }, {total:0, totalPaid:0})
    }, [bills])
        
    function renderBills(){
        if(bills.length === 0){
            return <Card>No bills</Card>
        }
        else{
            return <BillsTable patients={[patient]} currency={currency} bills={bills} languageCode={languageCode} 
                        hideSearchPatient={true}
                        hideInsuranceFilter={true}
                        canCreateBugdet={canCreateBugdet}
                        canCancelDocument={canCancelDocument}
                        hasBudgets={hasBudgets}
                        insurances={insurances || []}
                        makeActionBillCallBack={makeActionBillCallBack}/>
        }
    }
    return (
        <Grid container xs={12} spacing={3}>
            <Grid item xs={12}>
                <Card style={{padding:"1rem"}}>
                    <PatientInfo uuidPatient={uuidPatient} 
                        auxiliarInfo={[{title:"hospital.billing.total_amount", value:totalBills.total+" "+currency}, {title:"hospital.billing.total_paid", value:totalBills.totalPaid+" "+currency}]} />
                </Card>
            </Grid>
            <Grid item xs={12}>
            {
                renderBills()
            }
            </Grid>
        </Grid>
    );
};

export default BillsPatient;
